var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93.547,
    height: 28,
    viewBox: "0 0 93.547 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30D8\\u30C3\\u30C0\\u30FC\\u30ED\\u30B4",
    transform: "translate(-20 -20)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_520",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 520",
    transform: "translate(20 20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_25",
    "data-name": "\\u30D1\\u30B9 25",
    d: "M-419.031,250a3.372,3.372,0,0,1,3.368,3.368,3.358,3.358,0,0,1-3.368,3.34,3.372,3.372,0,0,1-3.395-3.34A3.385,3.385,0,0,1-419.031,250m0-3.816a7.191,7.191,0,0,0-7.183,7.184v13.624h4.094v-7.157l.154.063a7.138,7.138,0,0,0,2.935.653,7.067,7.067,0,0,0,5.052-2.1,7.267,7.267,0,0,0,2.1-5.136,7.238,7.238,0,0,0-7.156-7.128",
    transform: "translate(426.214 -238.993)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_26",
    "data-name": "\\u30D1\\u30B9 26",
    d: "M-375.068,256.708a3.372,3.372,0,0,1-3.395-3.34A3.385,3.385,0,0,1-375.068,250a3.371,3.371,0,0,1,3.367,3.368,3.358,3.358,0,0,1-3.367,3.34m0-10.523a7.191,7.191,0,0,0-7.183,7.184,7.191,7.191,0,0,0,7.183,7.184,7.178,7.178,0,0,0,7.155-7.184,7.177,7.177,0,0,0-7.155-7.184",
    transform: "translate(398.782 -238.974)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_27",
    "data-name": "\\u30D1\\u30B9 27",
    d: "M-326.942,242.228a3.328,3.328,0,0,1-3.332,3.261,3.287,3.287,0,0,1-3.264-3.419,3.236,3.236,0,0,1,3.258-3.232h.092a3.157,3.157,0,0,1,2.227.936,3.4,3.4,0,0,1,1.02,2.456m-3.171-7.206h-.067a5.96,5.96,0,0,0-3.247,1.028v-7.774h-4.121v13.819a7.312,7.312,0,0,0,2.2,5.131,7.146,7.146,0,0,0,5.05,2.135h.05a7.321,7.321,0,0,0,7.21-7.239,7.08,7.08,0,0,0-7.07-7.1",
    transform: "translate(370.889 -227.789)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_28",
    "data-name": "\\u30D1\\u30B9 28",
    d: "M-289.994,226.984h-.052a2.5,2.5,0,0,0-2.469,2.292,2.237,2.237,0,0,0,.674,1.666,2.541,2.541,0,0,0,1.771.776h.047a2.358,2.358,0,0,0,1.686-.74,2.367,2.367,0,0,0,.665-1.726,2.359,2.359,0,0,0-2.322-2.267",
    transform: "translate(342.801 -226.983)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_3",
    "data-name": "\\u9577\\u65B9\\u5F62 3",
    width: 4.038,
    height: 13.45,
    transform: "translate(50.702 7.573)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_29",
    "data-name": "\\u30D1\\u30B9 29",
    d: "M-262.689,255.414a3.213,3.213,0,0,1-2.564,1.34,3.323,3.323,0,0,1-3.479-3.311,3.5,3.5,0,0,1,3.479-3.423,3.545,3.545,0,0,1,2.4,1.123l.131.117,2.8-2.595-.2-.176a7.13,7.13,0,0,0-5.135-2.231,7.22,7.22,0,0,0-7.239,7.184,7.206,7.206,0,0,0,7.239,7.155,7.237,7.237,0,0,0,5.316-2.459l.085-.092L-262.6,255.3Z",
    transform: "translate(330.299 -239.02)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_4",
    "data-name": "\\u9577\\u65B9\\u5F62 4",
    width: 3.955,
    height: 20.557,
    transform: "translate(72.665 0.487)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_30",
    "data-name": "\\u30D1\\u30B9 30",
    d: "M-208.389,250a3.127,3.127,0,0,1,2.762,1.543h-5.568A3.259,3.259,0,0,1-208.389,250m0-3.816a7.192,7.192,0,0,0-7.183,7.184,7.228,7.228,0,0,0,7.183,7.183,7,7,0,0,0,5.064-2.122l.09-.093-2.709-2.709-.093.089a3.328,3.328,0,0,1-2.353.991,3.321,3.321,0,0,1-3.113-2.043h10.173l.012-.118c.014-.14.084-.86.084-1.179a7.178,7.178,0,0,0-7.156-7.184",
    transform: "translate(294.78 -238.974)",
    fill: "var(--primary-color)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSimple);
export default __webpack_public_path__ + "static/media/logo_simple.2432b5df92256dfd71c35a5639950239.svg";
export { ForwardRef as ReactComponent };